import { TrainingsCategoriesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useTrainingsCategories = () => {
  const { loading, data } = useQuery(TrainingsCategoriesDocument)

  return {
    loading,
    categories: data ? data.trainings.categories : undefined, // Provide a default value
  }
}
